import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import {
    GetCrecaTradesHistoryRequestModel,
    GetCrecaTradesHistoryResponseModel,
} from "@/features/accounts/creca/services/get-trades-history-model";

export class GetCrecaTradesHistoryApi {
    /**
     * クレカ取込履歴取得API
     */
    public getCrecaTradesHistory = async (
        param: GetCrecaTradesHistoryRequestModel,
    ): Promise<GetCrecaTradesHistoryResponseModel> => {
        const path = `/api/crecaaccounts/crecas/tradeshistory`;
        const res = await ApiClient.instance.get<GetCrecaTradesHistoryResponseModel>({
            path: path,
            params: param as NonNullable<unknown>,
        });

        if (res.ok === false) {
            throw MoneyLinkException.fromServer({ response: res });
        }

        return res.body;
    };
}
